
const LegacyTitle = () => {
    return (
        <div className="legacy-hero d-flex flex-column align-items-center justify-content-end  text-white">
            <div className="container-fluid">
                <h1 className="text-white mb-5 text-center text-lg-start">Our Legacy</h1>
            </div>
            <div className="container">
                <p className=" text-white pt-5 d-none d-lg-block p-md-5 p-lg-0">
                    Our journey is built on a strong foundation of expertise, innovation, and commitment to excellence.
                    With decades of expertise in branding, design, and audience engagement, we seamlessly transitioned
                    into curating impactful events.
                </p>
            </div>
        </div>

    );
};

export default LegacyTitle;
